import { ReactElement } from 'react';

import { mapSharedPropertiesToFields } from '../../../getters';
import { SitecoreFieldTypes } from '../../../types';
import { JabraFocusItem } from '../../JabraFocus';
import { ScopedStyle } from '../../ScopedStyle/ScopedStyle';
import { MajorLinkSmallCard } from '../MegaMenuTypes';
import {
  CARDS_BG_COLORS,
  getBgBasedColor,
  getRandomBGColor,
  getSmallCardsContainerGridColumnsClass,
} from '../MegaMenuUtils';
import { BackgroundImage } from './BackgroundImage';

import styles from './Cards.module.css';

interface SmallCardsGroupProps {
  items: {
    id: string;
    fields: SitecoreFieldTypes;
  }[];
}

export const SmallCardsGroup = ({ items }: SmallCardsGroupProps): ReactElement | null => {
  return (
    <div
      className={`justify-self-starts col-span-1 basis-1/2 auto-rows-fr ${
        styles.gridBase
      } ${getSmallCardsContainerGridColumnsClass(items.length)}`}
    >
      {items.map((card) => {
        const cardSettings = mapSharedPropertiesToFields<MajorLinkSmallCard>(card.fields);

        const isBackgroundImageSet =
          !!cardSettings.BackgroundImage?.value?.src ||
          !!cardSettings.backgroundImageExternalLink?.value?.href;
        const bgColor = isBackgroundImageSet ? CARDS_BG_COLORS[1] : getRandomBGColor(card.id);
        const bgBasedColor = getBgBasedColor(bgColor).text;
        return cardSettings.Link ? (
          <ScopedStyle
            key={card.id}
            id={card.id}
            css={cardSettings.Style?.value}
            renderItem={(styleLinkingProp) => (
              <JabraFocusItem asChild key={card.id}>
                <a
                  href={cardSettings.Link?.value?.href}
                  className={`no-underline hover:no-underline ${styles.card} ${styles.smallCard} ${bgColor} ${bgBasedColor}`}
                  {...styleLinkingProp}
                >
                  {isBackgroundImageSet && (
                    <div className="relative w-[75%] flex-1">
                      <BackgroundImage
                        field={cardSettings.BackgroundImage}
                        externalField={{
                          src: cardSettings.backgroundImageExternalLink?.value?.href,
                          altText: cardSettings.Header?.value,
                        }}
                        cardType="small"
                      />
                    </div>
                  )}
                  <p className={`content-center justify-center ${styles.header}`}>
                    {cardSettings.Header?.value}
                  </p>
                </a>
              </JabraFocusItem>
            )}
          />
        ) : null;
      })}
    </div>
  );
};
